<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ secureFinancingTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ secureFinancingSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!--
            <div class="center">
                <div class="left">
                    <div class="center-info">
                        <span class="text-paragraph infoTitle">
                            {{ without | translate }}
                        </span>
                        <p></p>
                        <b
                            ><span style="font-weight: bold" class="text-paragraph costTitle"
                                >+0.00 €/mes (formatear myDecimalPipe + myCurrencyPipe)</span
                            ></b
                        >
                        <p></p>
                        <span class="text-paragraph">{{ withoutInfo | translate }}</span>
                        <b
                            ><span style="font-weight: bold" class="text-paragraph">{{ withoutInfo2 | translate }}</span></b
                        >

                        <p></p>
                        <p></p>
                        <div class="continue">
                            <button
                                pripple=""
                                class="button-secondary button-next button-without"
                                type="button"
                                (click)="onClicButtonContinueWithout()"
                                [ngClass]="{ 'is-portrait': isPortraitDevice }"
                            >
                                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="center-info">
                        <span class="text-paragraph infoTitle">
                            {{ totalProtection | translate }}
                        </span>
                        <p></p>
                        <b
                            ><span style="font-weight: bold" class="text-paragraph costTitle"
                                >+19.11 €/mes(formatear myDecimalPipe + myCurrencyPipe)</span
                            ></b
                        >
                        <p></p>
                        <div>
                            <ul>
                                <li>
                                    <span class="text-paragraph">{{ totalProtectionInfo | translate }}</span>
                                </li>
                                <li>
                                    <span class="text-paragraph">{{ totalProtectionInfo2 | translate }}</span>
                                </li>
                                <li>
                                    <span class="text-paragraph">{{ totalProtectionInfo3 | translate }}</span>
                                </li>
                            </ul>
                        </div>
                        <p></p>
                        <p></p>

                        <div class="continue">
                            <button
                                pripple=""
                                class="button-primary button-next button-total"
                                type="button"
                                (click)="onClicButtonContinueTotal()"
                                [ngClass]="{ 'is-portrait': isPortraitDevice }"
                            >
                                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
 -->

            <div class="insurance-options">
                <div class="insurance-option1">
                    <div class="insurance-option1-header">
                        <span class="title">
                            {{ without | translate }}
                        </span>

                        <span class="subtitle"> + 0.00 €/mes</span>
                    </div>

                    <div class="text">
                        <span class="text-paragraph">
                            {{ withoutInfo | translate }}
                        </span>
                        <span style="font-weight: bold" class="text-paragraph">
                            {{ withoutInfo2 | translate }}
                        </span>
                    </div>

                    <div class="continue-without">
                        <button
                            pripple=""
                            class="button-secondary button-next button-without"
                            type="button"
                            (click)="onClicButtonContinueWithout()"
                            [ngClass]="{ 'is-portrait': isPortraitDevice }"
                        >
                            <span class="p-button-label-left text-without">{{ continueButton | translate }}</span>
                        </button>
                    </div>
                </div>

                <div class="insurance-option2">
                    <div class="option2-content">
                        <div class="option2-content-header">
                            <span class="title">
                                {{ secureName }}
                            </span>

                            <span class="subtitle"> + {{ secureMonthlyPrice }} €/mes</span>
                        </div>

                        <ul class="features-list">
                            <li class="simple-list">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6.66712 10.1141L12.7954 3.98584L13.7382 4.92865L6.66712 11.9997L2.42447 7.75709L3.36728 6.81429L6.66712 10.1141Z"
                                            fill="#3C3C3B"
                                        />
                                    </svg>
                                </div>
                                <span class="item">{{ totalProtectionInfo | translate }}</span>
                            </li>
                            <li class="simple-list">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6.66712 10.1141L12.7954 3.98584L13.7382 4.92865L6.66712 11.9997L2.42447 7.75709L3.36728 6.81429L6.66712 10.1141Z"
                                            fill="#3C3C3B"
                                        />
                                    </svg>
                                </div>
                                <span class="item">{{ totalProtectionInfo2 | translate }}</span>
                            </li>
                            <li class="simple-list">
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6.66712 10.1141L12.7954 3.98584L13.7382 4.92865L6.66712 11.9997L2.42447 7.75709L3.36728 6.81429L6.66712 10.1141Z"
                                            fill="#3C3C3B"
                                        />
                                    </svg>
                                </div>
                                <span class="item">{{ totalProtectionInfo3 | translate }}</span>
                            </li>
                        </ul>

                        <div class="continue">
                            <button
                                pripple=""
                                class="button-primary button-next button-total"
                                type="button"
                                (click)="onClicButtonContinueTotal()"
                                [ngClass]="{ 'is-portrait': isPortraitDevice }"
                            >
                                <span class="p-button-label-left text-with">{{ continueButton | translate }}</span>
                            </button>

                            <!------------------------>
                            <!-----popupInsurance----->
                            <!------------------------>

                            <p-dialog [(visible)]="visiblePopUpInsurance" [modal]="true" class="simulator-panel" styleClass="disable-scroll">
                                <ng-template pTemplate="headless">
                                    <div class="close-dialog-button-box">
                                        <button id="closeButton" class="close-dialog-button" type="button" (click)="onClosePopUpInsurance()">
                                            <i class="ri-close-fill close-dialog-icon"></i>
                                        </button>
                                    </div>

                                    <div class="modal-content">
                                        <div class="top">
                                            <div class="icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="89" height="88" viewBox="0 0 89 88" fill="none">
                                                    <path
                                                        d="M44.6819 0C53.3843 0 61.8912 2.58055 69.127 7.41534C76.3627 12.2501 82.0023 19.122 85.3326 27.1619C88.6628 35.2019 89.5342 44.0488 87.8364 52.584C86.1387 61.1191 81.9481 68.9592 75.7946 75.1127C69.6411 81.2662 61.801 85.4568 53.2658 87.1545C44.7307 88.8523 35.8838 87.9809 27.8438 84.6507C19.8039 81.3204 12.932 75.6808 8.09722 68.4451C3.26244 61.2093 0.681885 52.7024 0.681885 44C0.681885 32.3305 5.31758 21.1389 13.5692 12.8873C21.8208 4.6357 33.0124 0 44.6819 0Z"
                                                        fill="#3C3C3B"
                                                    />
                                                    <path
                                                        d="M25.2584 43.4755L34.5382 54.4873L63.3819 27.8758C63.3819 27.8758 65.6902 24.9667 67.9621 27.3156C69.959 29.4082 66.8536 32.0228 66.8536 32.0228L36.3151 60.8005C36.3151 60.8005 33.8147 62.9201 32.147 60.8005L21.4203 47.2155C21.0897 46.905 20.8344 46.523 20.674 46.0988C20.5136 45.6746 20.4523 45.2193 20.4948 44.7677C20.5372 44.3162 20.6823 43.8803 20.919 43.4934C21.1556 43.1065 21.4776 42.7788 21.8603 42.5354C21.8603 42.5354 23.6186 41.4938 25.2584 43.4755Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </div>

                                            <div class="text">
                                                <span class="header-title"> ¡Enhorabuena! </span>

                                                <span class="header-subtitle"> Has decidido proteger tu financiación </span>
                                            </div>
                                        </div>

                                        <div class="new-fee">
                                            <span class="new-fee-text"> Tu nueva cuota mensual será </span>

                                            <span class="new-fee-value"> {{ securePriceTotal }} €/mes </span>
                                        </div>

                                        <div class="breakdown">
                                            <div class="breakdown-row">
                                                <span class="label">Cuota inicial (sin seguro)</span>
                                                <div class="value">
                                                    <span class="text-value">{{ monthlyPrice }} €</span>
                                                </div>
                                            </div>

                                            <div class="breakdown-row">
                                                <span class="label">Coste mensual seguro “Protección Total”</span>
                                                <div class="value">
                                                    <span class="text-value">{{ secureMonthlyPrice }} €</span>
                                                </div>
                                            </div>

                                            <div class="breakdown-total-row">
                                                <span class="label">Cuota final (con seguro)</span>
                                                <div class="value">
                                                    <span class="text-value">+ {{ securePriceTotal }} €</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="bottom">
                                            <div class="actions">
                                                <button
                                                    pripple=""
                                                    class="button-primary button-next button-new-fee"
                                                    type="button"
                                                    legalTextInsurance
                                                    (click)="onClicButtonContinueWithout()"
                                                    [ngClass]="{ 'is-portrait': isPortraitDevice }"
                                                >
                                                    <span class="p-button-label-left text">{{ continueButton | translate }}</span>
                                                </button>
                                            </div>

                                            <span class="legal-text"> {{ legalTextInsurance | translate }} </span>
                                        </div>
                                    </div>
                                </ng-template>

                                <!--
                                <div class="modal-content">
                                    <div class="top">
                                        <div class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="89" height="88" viewBox="0 0 89 88" fill="none">
                                                <path
                                                    d="M44.6819 0C53.3843 0 61.8912 2.58055 69.127 7.41534C76.3627 12.2501 82.0023 19.122 85.3326 27.1619C88.6628 35.2019 89.5342 44.0488 87.8364 52.584C86.1387 61.1191 81.9481 68.9592 75.7946 75.1127C69.6411 81.2662 61.801 85.4568 53.2658 87.1545C44.7307 88.8523 35.8838 87.9809 27.8438 84.6507C19.8039 81.3204 12.932 75.6808 8.09722 68.4451C3.26244 61.2093 0.681885 52.7024 0.681885 44C0.681885 32.3305 5.31758 21.1389 13.5692 12.8873C21.8208 4.6357 33.0124 0 44.6819 0Z"
                                                    fill="#3C3C3B"
                                                />
                                                <path
                                                    d="M25.2584 43.4755L34.5382 54.4873L63.3819 27.8758C63.3819 27.8758 65.6902 24.9667 67.9621 27.3156C69.959 29.4082 66.8536 32.0228 66.8536 32.0228L36.3151 60.8005C36.3151 60.8005 33.8147 62.9201 32.147 60.8005L21.4203 47.2155C21.0897 46.905 20.8344 46.523 20.674 46.0988C20.5136 45.6746 20.4523 45.2193 20.4948 44.7677C20.5372 44.3162 20.6823 43.8803 20.919 43.4934C21.1556 43.1065 21.4776 42.7788 21.8603 42.5354C21.8603 42.5354 23.6186 41.4938 25.2584 43.4755Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </div>

                                        <div class="text">
                                            <span class="header-title"> ¡Enhorabuena! </span>

                                            <span class="header-subtitle"> Has decidido proteger tu financiación </span>
                                        </div>
                                    </div>

                                    <div class="new-fee">
                                        <span class="new-fee-text"> Tu nueva cuota mensual será </span>

                                        <span class="new-fee-value"> 976,04 €/mes </span>
                                    </div>

                                    <div class="breakdown">
                                        <div class="breakdown-row">
                                            <span class="label">Cuota inicial (sin seguro)</span>
                                            <div class="value">
                                                <span class="text-value">956,93 €</span>
                                            </div>
                                        </div>

                                        <div class="breakdown-row">
                                            <span class="label">Coste mensual seguro “Protección Total”</span>
                                            <div class="value">
                                                <span class="text-value">19,11 €</span>
                                            </div>
                                        </div>

                                        <div class="breakdown-total-row">
                                            <span class="label">Cuota final (con seguro)</span>
                                            <div class="value">
                                                <span class="text-value">976,04</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="bottom">
                                        <div class="actions">
                                            <button
                                                pripple=""
                                                class="button-primary button-next button-new-fee"
                                                type="button"
                                                (click)="onClicButtonContinueWithout()"
                                                [ngClass]="{ 'is-portrait': isPortraitDevice }"
                                            >
                                                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                                                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
                                            </button>
                                        </div>

                                        <span class="legal-text">
                                            Ejemplo de financiación para Jaguar E-Pace 24MY 2.0D I4 163 PS AWD Auto MHEV R-Dynamic S PVP: 63.000 €
                                            (incluye IVA, transporte, impuesto de matriculación calculado al tipo general, descuentos del
                                            concesionario y fabricante. Gastos de matriculación no incluidos) Precio financiando: 61.877,00 €.
                                            Entrada: 14.917,50 €. Comisión de formalización del 1,95% a pagar al contado: 915,71 €. Importe
                                            financiado: 46.959,50 €. 59 cuotas de 500,00 € y una última cuota de 26.656,33. TIN 4,95%. TAE 5,65%.
                                            Total intereses: 9.196,83 €. Coste total del crédito: 10.112,54 €. Importe total adeudado: 57.072,04 €.
                                            Precio total a plazos: 71.989,54. Sistema de amortización francés. Financiación concertada bajo la marca
                                            Land Rover Financiar Services (Marca registrada de JAGUAR LAND ROVER LIMITED) a través de Banco Cetelem
                                            S.A.U. para pedidos realizados hasta el DD/MM/AAAA en Península y Baleares, y no sufrirá modificación
                                            salvo variación de los impuestos.
                                        </span>
                                    </div>
                                </div>
 -->
                            </p-dialog>
                        </div>
                    </div>

                    <div class="option2-link">
                        <!--
                        <div class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                <path
                                    d="M7.5 0.583496L12.2932 1.64865C12.5601 1.70796 12.75 1.94469 12.75 2.2181V8.04369C12.75 9.21391 12.1651 10.3067 11.1914 10.9559L7.5 13.4168L3.80855 10.9559C2.83486 10.3067 2.25 9.21391 2.25 8.04369V2.2181C2.25 1.94469 2.43989 1.70796 2.70679 1.64865L7.5 0.583496ZM7.5 1.77862L3.41667 2.68603V8.04369C3.41667 8.82384 3.80657 9.55236 4.4557 9.98514L7.5 12.0147L10.5443 9.98514C11.1934 9.55236 11.5833 8.82384 11.5833 8.04369V2.68603L7.5 1.77862ZM10.0972 4.79623L10.9222 5.62119L7.20985 9.3335L4.73499 6.85865L5.55996 6.03364L7.20944 7.68319L10.0972 4.79623Z"
                                    fill="#013D8D"
                                />
                            </svg>
                        </div>
                        <span class="text">Coberturas y condiciones</span>
 -->
                        <!------------------------>
                        <!-----popupCoverage------>
                        <!------------------------>

                        <button id="closeButton" class="option2-link" type="button" (click)="onClicButtonCoverage()">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                                    <path
                                        d="M7.5 0.583496L12.2932 1.64865C12.5601 1.70796 12.75 1.94469 12.75 2.2181V8.04369C12.75 9.21391 12.1651 10.3067 11.1914 10.9559L7.5 13.4168L3.80855 10.9559C2.83486 10.3067 2.25 9.21391 2.25 8.04369V2.2181C2.25 1.94469 2.43989 1.70796 2.70679 1.64865L7.5 0.583496ZM7.5 1.77862L3.41667 2.68603V8.04369C3.41667 8.82384 3.80657 9.55236 4.4557 9.98514L7.5 12.0147L10.5443 9.98514C11.1934 9.55236 11.5833 8.82384 11.5833 8.04369V2.68603L7.5 1.77862ZM10.0972 4.79623L10.9222 5.62119L7.20985 9.3335L4.73499 6.85865L5.55996 6.03364L7.20944 7.68319L10.0972 4.79623Z"
                                        fill="#013D8D"
                                    />
                                </svg>
                            </div>

                            <span class="text">Coberturas y condiciones</span>
                        </button>

                        <p-dialog [(visible)]="visiblePopUpCoverage" [modal]="true" class="simulator-panel popUpCoverage" styleClass="disable-scroll">
                            <ng-template pTemplate="headless">
                                <div class="close-dialog-button-box">
                                    <button id="closeButton" class="close-dialog-button" type="button" (click)="onClosePopUpCoverage()">
                                        <i class="ri-close-fill close-dialog-icon"></i>
                                    </button>
                                </div>

                                <div class="modal-content-popUpCoverage">
                                    <div class="top">
                                        <div class="text">
                                            <span class="header-title"> Protección Total </span>

                                            <span class="header-subtitle"> + {{ secureMonthlyPrice }} €/mes </span>
                                        </div>
                                    </div>

                                    <div class="placeholder-content">
                                        <div class="feature">
                                            <div class="feature-box">
                                                <i class="ri-close-fill icon"></i>
                                            </div>

                                            <div class="feature-text">
                                                <span class="feature-text-header"> Fallecimiento o incapacidad permanente </span>

                                                <span class="feature-text-paragraph">
                                                    En caso de fallecimiento o incapacidad permanente por enfermedad o accidente, nos hacemos cargo de
                                                    la cancelación dando por finalizado tu préstamo.
                                                </span>
                                            </div>
                                        </div>

                                        <div class="feature">
                                            <div class="feature-box">
                                                <i class="ri-close-fill icon"></i>
                                            </div>

                                            <div class="feature-text">
                                                <span class="feature-text-header"> Desempleo o incapacidad temporal </span>

                                                <span class="feature-text-paragraph">
                                                    En caso de pérdida de empleo (para asalariados con contrato indefinido) o de incapacidad temporal
                                                    por enfermedad o accidente (para autónomos, funcionarios o asalariados con contrato temporal) nos
                                                    hacemos cargo de tus cuotas mensuales (máximo 18 mensualidades consecutivas o 36 alternativas).
                                                </span>
                                            </div>
                                        </div>

                                        <div class="feature">
                                            <div class="feature-box">
                                                <i class="ri-close-fill icon"></i>
                                            </div>

                                            <div class="feature-text">
                                                <span class="feature-text-header"> Hospitalización </span>

                                                <span class="feature-text-paragraph">
                                                    En caso de una enfermedad o accidente que ocasiones una hospitalización, nos hacemos cargo de una
                                                    cuota mensual.
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="bottom">
                                        <div class="actions">
                                            <button
                                                pripple=""
                                                class="button-primary button-next button-new-fee"
                                                type="button"
                                                (click)="onClicButtonContinueWithout()"
                                                [ngClass]="{ 'is-portrait': isPortraitDevice }"
                                            >
                                                <span class="p-button-label-left text">{{ continueButton | translate }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                    </div>
                </div>
            </div>
        </form>

        <div class="more-info">
            <label for=""
                >* Seguro mediado por Banco Cetelem, S.A.U Operador de Banca Seguros Vinculado y asegurado por Cardif Assurance Vie y Cardif
                Assurances Risques Divers.</label
            >
        </div>

        <!--
        <div class="actions">

            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

        </div>
         -->
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>

<!--
<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="headlines">
        <span *ngIf="!isPortraitDevice" class="text-headline-title">
            {{ secureFinancingTitle | translate }}
        </span>

        <span class="text-paragraph">
            {{ secureFinancingSubtitle | translate }}
        </span>
    </div>
    <div class="center">
        <div class="left">
            <div class="center-info">
                <span class="text-paragraph infoTitle">
                    {{ without | translate }}
                </span>
                <p></p>
                <b><span style="font-weight: bold" class="text-paragraph costTitle">+0.00 €/mes (formatear myDecimalPipe + myCurrencyPipe)</span></b>
                <p></p>
                <span class="text-paragraph">{{ withoutInfo | translate }}</span>
                <b
                    ><span style="font-weight: bold" class="text-paragraph">{{ withoutInfo2 | translate }}</span></b
                >

                <p></p>
                <p></p>
                <div class="continue">
                    <button
                        pripple=""
                        class="button-secondary button-next button-without"
                        type="button"
                        (click)="onClicButtonContinueWithout()"
                        [ngClass]="{ 'is-portrait': isPortraitDevice }"
                    >
                        <span class="p-button-label-left">{{ continueButton | translate }}</span>
                        <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="center-info">
                <span class="text-paragraph infoTitle">
                    {{ totalProtection | translate }}
                </span>
                <p></p>
                <b><span style="font-weight: bold" class="text-paragraph costTitle">+19.11 €/mes(formatear myDecimalPipe + myCurrencyPipe)</span></b>
                <p></p>
                <div>
                    <ul>
                        <li>
                            <span class="text-paragraph">{{ totalProtectionInfo | translate }}</span>
                        </li>
                        <li>
                            <span class="text-paragraph">{{ totalProtectionInfo2 | translate }}</span>
                        </li>
                        <li>
                            <span class="text-paragraph">{{ totalProtectionInfo3 | translate }}</span>
                        </li>
                    </ul>
                </div>
                <p></p>
                <p></p>

                <div class="continue">
                    <button
                        pripple=""
                        class="button-primary button-next button-total"
                        type="button"
                        (click)="onClicButtonContinueTotal()"
                        [ngClass]="{ 'is-portrait': isPortraitDevice }"
                    >
                        <span class="p-button-label-left">{{ continueButton | translate }}</span>
                        <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="actions">
        <button
            *ngIf="!isPortraitDevice"
            pripple=""
            class="button-secondary button-next"
            type="button"
            [disabled]="backButtonDisabled"
            (click)="onClicButtonBack()"
        >
            <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
            <span class="p-button-label-right">{{ backButton | translate }}</span>
        </button>
    </div>
</div>
 -->
